import React, { useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export const ChangePassword = () => {
  const [f, setF] = useState({ current: "", next: "", again: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 8) return toast.error("Yeni şifre en az 8 karakter olmalı");
    if (f.next !== f.again) return toast.error("Yeni şifreler eşleşmiyor");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Şifre değiştirildi");
      setF({ current: "", next: "", again: "" });
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Değiştirilemedi");
    } finally { setBusy(false); }
  };

  return (
    <Card className="p-6" data-testid="change-password-card">
      <h3 className="font-bold mb-3 flex items-center gap-2"><KeyRound size={16} /> Şifre Değiştir</h3>
      <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
        <div><Label>Mevcut Şifre</Label><Input type="password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} className="mt-1.5" data-testid="pw-current-input" /></div>
        <div><Label>Yeni Şifre</Label><Input type="password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} className="mt-1.5" data-testid="pw-new-input" /></div>
        <div><Label>Yeni Şifre (Tekrar)</Label><Input type="password" value={f.again} onChange={(e) => setF({ ...f, again: e.target.value })} className="mt-1.5" data-testid="pw-again-input" /></div>
        <Button type="submit" disabled={busy} className="md:col-span-3 md:w-auto md:justify-self-start" data-testid="pw-submit-btn">Şifreyi Güncelle</Button>
      </form>
    </Card>
  );
};
